import { Dialog as BaseDialog } from '@base-ui/react/dialog';
import type * as React from 'react';

import { cn } from '@/lib/utils';
import { Icon } from './icon';

export const Dialog = BaseDialog.Root;
export const DialogTrigger = BaseDialog.Trigger;
export const DialogClose = BaseDialog.Close;

interface DialogContentProps extends React.ComponentProps<typeof BaseDialog.Popup> {
  hideCloseButton?: boolean;
}

export function DialogContent({ className, children, hideCloseButton, ...props }: DialogContentProps) {
  return (
    <BaseDialog.Portal>
      <BaseDialog.Backdrop className="fixed inset-0 z-40 bg-black/50 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 transition-opacity" />
      <BaseDialog.Popup
        className={cn(
          'fixed top-1/2 left-1/2 z-40 w-full max-w-lg -translate-x-1/2 -translate-y-1/2',
          'border border-mesa-border bg-mesa-card p-6 shadow-lg',
          'data-[ending-style]:scale-95 data-[ending-style]:opacity-0 data-[starting-style]:scale-95 data-[starting-style]:opacity-0 transition-all',
          className
        )}
        {...props}
      >
        {children}
        {!hideCloseButton && (
          <BaseDialog.Close className="absolute top-4 right-4 opacity-70 hover:opacity-100">
            <Icon name="xmark" className="size-4" />
          </BaseDialog.Close>
        )}
      </BaseDialog.Popup>
    </BaseDialog.Portal>
  );
}

export function DialogHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('flex flex-col gap-2 text-center sm:text-left', className)} {...props} />;
}

export function DialogFooter({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end', className)} {...props} />;
}

export function DialogTitle({ className, ...props }: React.ComponentProps<typeof BaseDialog.Title>) {
  return <BaseDialog.Title className={cn('text-lg font-semibold', className)} {...props} />;
}

export function DialogDescription({ className, ...props }: React.ComponentProps<typeof BaseDialog.Description>) {
  return <BaseDialog.Description className={cn('text-sm text-mesa-muted', className)} {...props} />;
}
